import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfirmModalService {
  confirmModal = signal({
    title: '',
    message: '',
    confirm: null as (() => void) | null,
    cancel: null as (() => void) | null,
    show: undefined as undefined | boolean,
    inverted: undefined as undefined | boolean,
    confirmOnly: undefined as undefined | boolean
  });

  constructor() {}

  showModal(
    title: string,
    message: string,
    confirm: () => void,
    cancel?: () => void,
    inverted?: boolean,
    confirmOnly?: boolean
  ) {
    this.confirmModal.set({
      title,
      message,
      confirm: () => {
        confirm();
        this.hideModal();
      },
      cancel: () => {
        if (cancel) {
          cancel();
        }
        this.hideModal();
      },
      show: true,
      inverted,
      confirmOnly
    });
  }

  hideModal() {
    this.confirmModal.update((m) => {
      return { ...m, show: false };
    });
  }
}
